import React from "react";
import { Delta, DeltaPolarity } from "@/shell/components/Delta";

export type KpiTint =
    | "primary"
    | "critical"
    | "high"
    | "warning"
    | "success"
    | "violet"
    | "teal"
    | "orange"
    | "lime"
    | "pink"
    | "muted";

type Props = {
    icon: string;
    label: string;
    value: string;
    mom?: number | null;
    unit?: "%" | "pp";
    sub?: string;
    tint?: KpiTint;
    deltaPolarity?: DeltaPolarity;
};

export const KpiCard: React.FC<Props> = ({
    icon,
    label,
    value,
    mom,
    unit,
    sub,
    tint = "primary",
    deltaPolarity,
}) => (
    <div className={`card kpi kpi--${tint}`}>
        <div className="kpi__icon">
            <span className="material-symbols-outlined">{icon}</span>
        </div>
        <div className="kpi__label">{label}</div>
        <div className="kpi__delta">
            <Delta value={mom} unit={unit} polarity={deltaPolarity} />
        </div>
        <div className="kpi__value num">{value}</div>
        {sub !== undefined && sub !== "" ? <div className="kpi__ctx">{sub}</div> : null}
    </div>
);
